import React from 'react';
import SEO from '../components/SEO';

export default function Contact() {
  return (
    <>
      <SEO 
        title="Contact Otso Co | Book a Free Discovery Call" 
        description="Ready to grow your pet care business on social media? Book a free discovery call with Perry Dasilva at Otso Co. Social media management and consulting for the pet care industry." 
        path="/contact" 
      />
      
      <section className="bg-brand-primaryDark text-brand-white py-24 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Let's Talk. <span className="text-brand-blush">No Pressure, No Pitch.</span>
          </h1>
          <p className="text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto">
            Book a free discovery call and let's figure out what your pet care business needs. Whether you want someone to handle everything or just need a solid strategy to follow yourself — I've got you.
          </p>
        </div>
      </section>

      <section className="py-24 px-4 bg-brand-blush/10">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-16 mb-16">
            {/* Form Container */}
            <div className="w-full lg:w-2/3 bg-brand-white p-4 md:p-8 rounded-3xl shadow-xl border border-gray-100 overflow-hidden">
              <h2 className="text-2xl font-bold mb-6 text-brand-primaryDark px-4">Tell Me About Your Business</h2>
              <div className="w-full h-[950px] overflow-hidden">
                <iframe 
                  src="https://emb.fouita.com/widget/0x3ec987/ft2qzq8o4" 
                  title="Registration Form" 
                  width="100%" 
                  height="100%" 
                  frameBorder="0" 
                  className="w-full h-full border-none"
                  style={{border: 'none'}}
                ></iframe>
              </div>
            </div>

            {/* Contact Info Block */}
            <div className="w-full lg:w-1/3">
              <div className="bg-brand-primaryDark text-brand-white p-10 rounded-3xl shadow-2xl lg:sticky lg:top-28">
                <h3 className="text-2xl font-bold mb-8 text-brand-blush">Get in Touch</h3>
                <div className="space-y-8">
                  <div>
                    <p className="text-sm font-bold text-brand-mediumPurple uppercase tracking-wider mb-1">Email</p>
                    <a href="mailto:hello@otsoco.com" className="text-2xl font-semibold hover:text-brand-blush transition-colors break-all">hello@otsoco.com</a>
                  </div>
                  <div>
                    <p className="text-sm font-bold text-brand-mediumPurple uppercase tracking-wider mb-1">Location</p>
                    <p className="text-xl">Laurel, Maryland</p>
                  </div>
                  
                  <div className="pt-8 border-t border-[#3b4485]">
                    <p className="text-sm font-bold text-brand-mediumPurple uppercase tracking-wider mb-4">Follow Me</p>
                    <div className="flex flex-col space-y-3">
                      <a href="https://facebook.com/theperrydasilva" target="_blank" rel="noopener noreferrer" className="text-lg hover:text-brand-blush transition-colors flex items-center">
                        Facebook: @theperrydasilva
                      </a>
                      <a href="https://instagram.com/theperrydasilva" target="_blank" rel="noopener noreferrer" className="text-lg hover:text-brand-blush transition-colors flex items-center">
                        Instagram: @theperrydasilva
                      </a>
                    </div>
                  </div>

                  <div className="pt-8 mt-8 bg-[#1f2552] -mx-10 -mb-10 p-10 rounded-b-3xl">
                    <p className="text-brand-blush italic text-lg leading-relaxed">
                      "I typically respond within 24 to 48 business hours."
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Testimonials Under the Form Area */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
            <div className="w-full overflow-hidden rounded-2xl shadow-lg border border-gray-100 bg-white">
              <iframe 
                id="socialjuice-testimonial-7473-adr8ae1fnph" 
                src="https://embed.socialjuice.io/testimonial/7473?t=adr8ae1fnph"  
                allowTransparency="true" 
                frameBorder="0" 
                scrolling="no" 
                width="100%" 
                height="315"
                title="Client Testimonial 1"
              ></iframe>
            </div>
            <div className="w-full overflow-hidden rounded-2xl shadow-lg border border-gray-100 bg-white">
              <iframe 
                id="socialjuice-testimonial-7473-7ubh11p221b" 
                src="https://embed.socialjuice.io/testimonial/7473?t=7ubh11p221b"  
                allowTransparency="true" 
                frameBorder="0" 
                scrolling="no" 
                width="100%" 
                height="315"
                title="Client Testimonial 2"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}